/* template */
<template><div v-if="(pageConfig)"><Index :pageConfig="(pageConfig)" :info="(info)" v-if="(show)"/><error-page :message="(pageErrorMessage)" :exception="(exception)" isKf v-else/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"md07f91ac"}'>
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "md07f91ac"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isFirst&isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!../../../node_modules/@didi/webpack-config-fin/lib/business/webp-loader.js!./index.mpx?ctorType=page&index=0&isFirst&isPage&lang=js&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["md07f91ac"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {"navigationBarTitleText":"","backgroundColor":"#ffffff"},
    // @ts-ignore
    {},
    // @ts-ignore
    {'error-page':()=>import(/* webpackChunkName: "error-page" */"../../components/common/error-page.mpx?async=error-page&isComponent&outputPath=components%2Ferror-page3cc89422%2Findex").then(res => getComponent(res)),'Index':getComponent(require("../../editor/hxz/index.mpx?isComponent&outputPath=components%2Findex15b94fca%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules),
    true
  )
</script>
